export default __webpack_public_path__ + "static/media/slide2.cd73bd51.jpg";